<template>
  <v-btn
    :fab="adaptToSmallScreen && $vuetify.breakpoint.xs"
    :round="!adaptToSmallScreen || $vuetify.breakpoint.smAndUp"
    dark
    fixed
    bottom
    right
    :style="{
      'margin-bottom':
        (adaptToSmallScreen && $vuetify.breakpoint.xs ? 64 : 48) + 'px',
    }"
    :class="$desktopModeStyles"
    class="msr z-index-3"
    @click.stop="$emit('click')"
  >
    <v-icon :left="!adaptToSmallScreen || $vuetify.breakpoint.smAndUp">
      textsms
    </v-icon>
    <span v-if="!adaptToSmallScreen || $vuetify.breakpoint.smAndUp">{{
      $t('createTicker')
    }}</span>
  </v-btn>
</template>

<script>
export default {
  props: {
    adaptToSmallScreen: {
      type: Boolean,
      default: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CreateTickerButton.vue